if (!customElements.get('product-sticky-bar')) {
	class ProductStickyBar extends HTMLElement {
		connectedCallback() {
			this.sectionId = this.dataset.section;
			this.buyBox = document.getElementById(`ProductBuyBox-${this.sectionId}`);
			this.mainPrice = document.getElementById(`price-${this.sectionId}`);
			this.stickyPrice = this.querySelector('.product-sticky-bar__price');
			this.mainSubmit = document.getElementById(
				`ProductSubmitButton-${this.sectionId}`
			);
			this.stickySubmit = this.querySelector('.product-sticky-bar__submit');
			this.mobileQuery = window.matchMedia('(max-width: 989px)');

			if (!this.buyBox || !this.stickySubmit) return;

			this.hasSeenBuyBox = false;

			this.intersectionObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							this.hasSeenBuyBox = true;
							this.toggleVisibility(false);
						} else if (this.hasSeenBuyBox) {
							this.toggleVisibility(true);
						}
					});
				},
				{ threshold: 0 }
			);
			this.intersectionObserver.observe(this.buyBox);

			this.mobileQuery.addEventListener('change', () => {
				if (!this.mobileQuery.matches) this.toggleVisibility(false);
			});

			if (this.mainPrice && this.stickyPrice) {
				this.priceObserver = new MutationObserver(() => this.syncPrice());
				this.priceObserver.observe(this.mainPrice, {
					childList: true,
					subtree: true,
					attributes: true,
					attributeFilter: ['class'],
				});
			}

			if (this.mainSubmit) {
				this.buttonObserver = new MutationObserver(() => this.syncButton());
				this.buttonObserver.observe(this.mainSubmit, {
					attributes: true,
					attributeFilter: ['disabled', 'class', 'aria-disabled'],
					childList: true,
					subtree: true,
					characterData: true,
				});

				this.stickySubmit.addEventListener('click', () => {
					if (this.mainSubmit.disabled) return;
					this.mainSubmit.click();
				});
			}

			this.syncPrice();
			this.syncButton();
		}

		toggleVisibility(show) {
			const visible = show && this.mobileQuery.matches;
			this.classList.toggle('product-sticky-bar--visible', visible);
			document.body.classList.toggle('sticky-add-to-cart-visible', visible);
		}

		syncPrice() {
			if (!this.mainPrice || !this.stickyPrice) return;

			const mainPriceEl = this.mainPrice.querySelector('.price');
			const stickyPriceEl = this.stickyPrice.querySelector('.price');

			if (mainPriceEl && stickyPriceEl) {
				stickyPriceEl.className = mainPriceEl.className;
				stickyPriceEl.innerHTML = mainPriceEl.innerHTML;
				return;
			}

			this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
		}

		syncButton() {
			if (!this.mainSubmit || !this.stickySubmit) return;

			this.stickySubmit.disabled = this.mainSubmit.disabled;

			const mainLabel = this.mainSubmit.querySelector(
				'.product-form__submit-label'
			);
			const stickyLabel = this.stickySubmit.querySelector(
				'.product-form__submit-label'
			);

			if (mainLabel && stickyLabel) {
				stickyLabel.textContent = mainLabel.textContent;
			}

			this.stickySubmit.classList.toggle(
				'loading',
				this.mainSubmit.classList.contains('loading')
			);

			if (this.mainSubmit.hasAttribute('aria-disabled')) {
				this.stickySubmit.setAttribute(
					'aria-disabled',
					this.mainSubmit.getAttribute('aria-disabled')
				);
			} else {
				this.stickySubmit.removeAttribute('aria-disabled');
			}
		}

		disconnectedCallback() {
			this.intersectionObserver?.disconnect();
			this.priceObserver?.disconnect();
			this.buttonObserver?.disconnect();
			document.body.classList.remove('sticky-add-to-cart-visible');
		}
	}

	customElements.define('product-sticky-bar', ProductStickyBar);
}
